import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  ElementRef,
  HostListener,
  inject,
  input,
  output,
  viewChild,
} from '@angular/core';
import { PortalService } from '../../../services/portal.service';

export interface ActionSheetItem {
  icon: string;
  label: string;
  variant?: 'default' | 'danger';
  handler: () => void;
}

@Component({
  selector: 'om-action-sheet',
  templateUrl: './action-sheet.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionSheet {
  private readonly portal = inject(PortalService);

  readonly isOpen = input(false);
  readonly actions = input<ActionSheetItem[]>([]);

  readonly closed = output<void>();

  readonly portalRef = viewChild<ElementRef<HTMLElement>>('sheetPortal');

  constructor() {
    this.portal.attach(this.portalRef, this.isOpen, inject(DestroyRef));
  }

  onAction(action: ActionSheetItem): void {
    action.handler();
    this.closed.emit();
  }

  onClose(): void {
    this.closed.emit();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.isOpen()) this.onClose();
  }
}
